
import { CustomSearch } from '@/shared/components/ui';
import { usePostValidarCodigoOtp, useGetFetchCodigoOtpSupervisor, usePutFetchCodOtp } from '@/shared/actions/erp';
import { useCheckPermissionsArray, useTableFilter } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { IDataCodigoOtp } from '@/shared/interfaces';
import { Grid, Typography } from '@mui/material';
import { useColumsTableOTPSupervisor } from '@/erp/codigos-otp/shared/hooks';
import { EstadoOTPChoiceEnum, gridSizeMdLg12 } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useState } from 'react';


export default function SolicitudOtpPendientePage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_codigootp,
    PermissionsEnum.api_change_codigootp,
  ]);

  const [open, setOpen] = useState<boolean>(false);

  //STORE
  const [dataOTP, setDataOTP] = useState<IDataCodigoOtp | null>(null);
  const fetchPutCodigoOtp = usePutFetchCodOtp({});

  //HOOK PERSONALIZADO
  const { columnsOtpSupervisor } = useColumsTableOTPSupervisor();

  //FETCH
  const fetchValidarCodigoOtp = usePostValidarCodigoOtp({});

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

    onChangeRangeDate,
    cleanFilter
  } = useTableFilter();


  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetFetchCodigoOtpSupervisor(
      {
        page: pageIndex + 1,
        page_size: pageSize,
        codigo: searchTerm,
        validado: false,
        estado_otp: EstadoOTPChoiceEnum.SOLICITADO
      }
    );

  const onEdit = (e: IDataCodigoOtp) => {

    setOpen(true)
    setDataOTP(e)

    /* setConfirmDialog({
      isOpen: true, title: 'Validar Código OTP', subtitle: `Al confirmar el número ${e.celular.replace('5939', '09')}
      con el digo OTP ${e.otp} del cliente se habilitara, ¿Quieres continuar?`, onClose() {
        setConfirmDialogIsOpen(false);
      }, async onConfirm() {
        setConfirmDialogIsOpen(false);
        await fetchValidarCodigoOtp.mutateAsync({
          codigo: e.otp,
          identificacion: e.prospecto_data.length === 0 ? '' : e.prospecto_data[0].identificacion
        });
      },
      btnTitle: 'Cerrar'
    }) */

  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text="por codigo"

            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataCodigoOtp>
            columns={columnsOtpSupervisor}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data.count}
            // // actions
            actionsColumnSize={120}
            // crud
            onEdit={onEdit}
            canDelete={false}
            positionActionsColumn='first'
          />
        </Grid>
      </Grid>

      {
        open && dataOTP && (
          <ScrollableDialogProps
            open={open}
            title={`Validar Código OTP`}
            width="69%"
            onCloseIcon={() => setOpen(false)}
            onConfirm={async () => {
              await fetchValidarCodigoOtp.mutateAsync({
                codigo: dataOTP.otp,
                identificacion: dataOTP.prospecto_data.length === 0 ? '' : dataOTP.prospecto_data[0].identificacion
              });
              setOpen(false)
              setDataOTP(null)
            }}
            confirmVariantBtn='contained'

            ///* rechazar
            onReject={async () => {
              await fetchPutCodigoOtp.mutateAsync({
                id_codigo_otp: dataOTP.id_codigo_otp,
                estado_otp: EstadoOTPChoiceEnum.EXPIRADO
              })
              setOpen(false)
              setDataOTP(null)

            }}
            showRejectBtn={true}
            contentNode={
              <>
                <Grid item xs={12} container spacing={1} alignItems="center">
                  <Grid item {...gridSizeMdLg12}>
                    <Typography>
                      {`Al confirmar el número ${dataOTP.celular.replace('5939', '09')} con el digo OTP ${dataOTP.otp} del cliente se habilitara, ¿Quieres continuar?`}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            }
          />
        )
      }
    </>
  );




}

